import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useFormik } from "formik";
import { validate } from "./utils";
import axios from "axios";

export const SignupPage = (props) => {
  const formik = useFormik({
    initialValues: {
      fullName: "",
      adId: "",
      email: "",
      departmentId: null,
      roleId: null,
    },
    validate,
    onSubmit: async (values) => {
      if (values.departmentId !== null && values.roleId !== null) {
        try {
          axios.post(
            `${window._env_.REACT_APP_SERVER}/user/createInactiveUser`,
            { newUser: values }
          );
          props.setIsVisible(false);
          props.setShowRequestAlert(true);
        } catch (e) {
          alert(e);
        }
      } else alert("Please select a department and role.");
    },
  });
  const [roles, setRoles] = React.useState(null);
  const [departments, setDepartments] = React.useState(null);
  React.useEffect(() => {
    axios
      .get(`${window._env_.REACT_APP_SERVER}/user/getAllRoles`)
      .then((res) => {
        setRoles(res.data);
      });

    axios
      .get(`${window._env_.REACT_APP_SERVER}/user/getAllDepartments`)
      .then((res) => {
        setDepartments(res.data);
      });
  }, []);

  return (
    <Modal show={props.isVisible} onHide={() => props.setIsVisible(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Request Access to Asset Inventory</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={formik.handleSubmit}>
          <Form.Group controlId="fullName">
            <Form.Label>Full Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your name"
              onChange={formik.handleChange}
              value={formik.values.fullName}
            />
            {formik.errors.fullName ? (
              <Form.Text className="text-danger">
                {formik.errors.fullName}
              </Form.Text>
            ) : null}
          </Form.Group>

          <Form.Group controlId="adId">
            <Form.Label>Active Directory ID</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your active directory id"
              onChange={formik.handleChange}
              value={formik.values.adId}
            />
            {formik.errors.adId ? (
              <Form.Text className="text-danger">
                {formik.errors.adId}
              </Form.Text>
            ) : null}
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label>AACO Email Address</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your email address"
              onChange={formik.handleChange}
              value={formik.values.email}
            />
            {formik.errors.email ? (
              <Form.Text className="text-danger">
                {formik.errors.email}
              </Form.Text>
            ) : null}
          </Form.Group>

          <Form.Group controlId="email">
            <Form.Label>Select your Department</Form.Label>
            <select
              className="form-control"
              id="departmentId"
              name="departmentId"
              required
              onChange={formik.handleChange}
              value={formik.values.departmentId}
            >
              <option selected disabled value={0}>
                Select...
              </option>
              {departments !== null &&
                departments.map((department, index) => {
                  return (
                    <option key={index} value={department.id}>
                      {department.Name}
                    </option>
                  );
                })}
            </select>
            {formik.errors.departmentId ? (
              <div className="text-danger">{formik.errors.departmentId}</div>
            ) : null}
          </Form.Group>

          {formik.errors.departmentId ? (
            <div className="text-danger">{formik.errors.departmentId}</div>
          ) : null}
          <label htmlFor="caseTypeId">Role</label>
          <select
            className="form-control"
            id="roleId"
            name="roleId"
            required
            onChange={formik.handleChange}
            value={formik.values.roleId}
          >
            <option selected disabled value={0}>
              Select...
            </option>
            {roles !== null &&
              roles.map((role, index) => {
                return (
                  <option key={index} value={role.id}>
                    {role.roleType}
                  </option>
                );
              })}
          </select>
          {formik.errors.roleId ? (
            <div className="text-danger">{formik.errors.roleId}</div>
          ) : null}
          <Button type="submit" variant="info" className="mt-3 float-right">
            Submit
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
